import { RefObject } from 'react'

import { useKeyCloak } from '@/hooks/useKeyCloak'

import { VStack } from '@chakra-ui/react'

import { Logout, Settings } from '@/components/icons'
import { BUTTON_PRESS, mixpanel } from '@/utils/analytics'
import { SETTINGS_MANAGEMENT } from '@/utils/routes'

import { HelpPopover } from './HelpPopover'
import { MenuItem } from './MenuItem'
import { MENU_CONTAINER_STYLES } from './constants'

interface ProfileMenuActionsIProps {
  isProfilePopoverOpen: boolean
  onHelpPopoverOpenChange: (isOpen: boolean) => void
  profilePopoverRef: RefObject<HTMLDivElement>
  onHelpPopoverRefChange: (ref: HTMLDivElement | null) => void
}

export const ProfileMenuActions = ({
  isProfilePopoverOpen,
  onHelpPopoverOpenChange,
  profilePopoverRef,
  onHelpPopoverRefChange,
}: ProfileMenuActionsIProps) => {
  const { logOut } = useKeyCloak()

  const handleSettingsClick = () => {
    mixpanel.track(`${BUTTON_PRESS} Settings`)
  }

  const handleLogoutClick = () => {
    mixpanel.track(`${BUTTON_PRESS} Logout`)
    logOut()
  }

  return (
    <VStack
      align='stretch'
      pt={MENU_CONTAINER_STYLES.PADDING_TOP}
      px={MENU_CONTAINER_STYLES.PADDING_X}
    >
      <HelpPopover
        isProfilePopoverOpen={isProfilePopoverOpen}
        onHelpPopoverOpenChange={onHelpPopoverOpenChange}
        onHelpPopoverRefChange={onHelpPopoverRefChange}
        profilePopoverRef={profilePopoverRef}
      />
      <MenuItem
        dataTestId='SideBarProfileMenu:settings'
        icon={Settings}
        onClick={handleSettingsClick}
        path={SETTINGS_MANAGEMENT}
        title='Settings'
        useStrokeColor
      />
      <MenuItem
        dataTestId='SideBarProfileMenu:logout'
        icon={Logout}
        onClick={handleLogoutClick}
        title='Logout'
        useStrokeColor
      />
    </VStack>
  )
}
